import { SystemModules } from "@domains/person/user/self/data";
import { PLATFORM_FEATURES } from "@application/config";

export enum EAccessIds {
    ACCESS_POINTS = 'access-points',
    AVERAGE_STAY = 'average-stay',
    PERSONAL_PREFERENCES = 'personal-preferences',
    EDGE_CONNECTION_REPORT = 'edge-connection-report',
    ACCESS_ADVERTISEMENT = 'access-advertisement',
    ACCESS_CONTROL = 'access-control',
    ACCESS_ENTRY = 'entry-messages',
    ACCESS_EXIT = 'exit-messages',
    ACCESS_EXPIRATION = 'expiration-messages',
    ACCESS_SUBSCRIPTION = 'subscription-status',
    ACCESS_ATTENTION = 'alert-messages',
    ACCESS_GROUPS = 'access-groups',
    SCHOOL_ACCESS_CONTROL = 'school-access-control',
    LATENESS = 'lateness',
    LATENESS_SCOPE = 'lateness-scope',
    ABSENCE_LIMIT = 'absence-limit',
    ABSENCE_LIMIT_SCOPE = 'absence-limit-scope',
    SCHOOL_ACCESS_MESSAGES = 'school-access-messages',
    TOTALPASS_CHECKIN = 'totalpass-checkin-settings',
    GYMPASS_CHECKIN = 'gympass-checkin-settings',
    CONTRACT_SIGNATURE = 'contract-signature-settings',
    INSTANT_MESSAGING = 'instant-messaging',
};

export const accessPageFragments = [
    {
        title: 'SETTINGS.ACCESS.EDGES.SUMMARY_LABEL',
        id: EAccessIds.ACCESS_POINTS,
    },
    {
        title: 'SETTINGS.ACCESS.AVERAGE_STAY.TITLE',
        id: EAccessIds.AVERAGE_STAY,
    },
    {
        title: 'SETTINGS.ACCESS.PERSONAL_PREFERENCES.TITLE',
        id: EAccessIds.PERSONAL_PREFERENCES,
    },
    {
        title: 'SETTINGS.ACCESS.ADVERTISEMENT',
        id: EAccessIds.ACCESS_ADVERTISEMENT,
    },
    {
        title: 'SETTINGS.ACCESS.CONTROL',
        id: EAccessIds.ACCESS_CONTROL,
        hiddenPlatformFeatures: [PLATFORM_FEATURES.school],
    },
    {
        title: 'SETTINGS.ACCESS.ENTRY',
        id: EAccessIds.ACCESS_ENTRY,
        hiddenPlatformFeatures: [PLATFORM_FEATURES.school],
    },
    {
        title: 'SETTINGS.ACCESS.LEAVE',
        id: EAccessIds.ACCESS_EXIT,
        hiddenPlatformFeatures: [PLATFORM_FEATURES.school],
    },
    {
        title: 'SETTINGS.ACCESS.MATURITY',
        id: EAccessIds.ACCESS_EXPIRATION,
        hiddenPlatformFeatures: [PLATFORM_FEATURES.school],
    },
    {
        title: 'SETTINGS.ACCESS.SIGNATURE',
        id: EAccessIds.ACCESS_SUBSCRIPTION,
        hiddenPlatformFeatures: [PLATFORM_FEATURES.school],
    },
    {
        title: 'SETTINGS.ACCESS.ATTENTION',
        id: EAccessIds.ACCESS_ATTENTION,
        hiddenPlatformFeatures: [PLATFORM_FEATURES.school],
    },
    {
        title: 'SETTINGS.ACCESS.CONTROL',
        id: EAccessIds.SCHOOL_ACCESS_CONTROL,
        requiredPlatformFeatures: [PLATFORM_FEATURES.school],
    },
    {
        title: 'SETTINGS.ACCESS.LATENESS.SUMMARY_LABEL',
        id: EAccessIds.LATENESS,
        requiredPlatformFeatures: [PLATFORM_FEATURES.school],
    },
    {
        title: 'SETTINGS.ACCESS.ABSENCE_LIMIT.SUMMARY_LABEL',
        id: EAccessIds.ABSENCE_LIMIT,
        requiredPlatformFeatures: [PLATFORM_FEATURES.school],
    },
    {
        title: 'SETTINGS.ACCESS.LATENESS.SCOPE.SUMMARY_LABEL',
        id: EAccessIds.LATENESS_SCOPE,
        requiredPlatformFeatures: [PLATFORM_FEATURES.school],
    },
    {
        title: 'SETTINGS.ACCESS.ABSENCE_LIMIT.SCOPE.SUMMARY_LABEL',
        id: EAccessIds.ABSENCE_LIMIT_SCOPE,
        requiredPlatformFeatures: [PLATFORM_FEATURES.school],
    },
    {
        title: 'SETTINGS.ACCESS.SCHOOL_MESSAGES.SUMMARY_LABEL',
        id: EAccessIds.SCHOOL_ACCESS_MESSAGES,
        requiredPlatformFeatures: [PLATFORM_FEATURES.school],
    },
    {
        title: 'SETTINGS.ACCESS.CONTRACT_SIGNATURE.SUMMARY_LABEL',
        id: EAccessIds.CONTRACT_SIGNATURE,
    },
    // {
    //   title: 'SETTINGS.ACCESS.ACCESS_GROUPS',
    //   id: EAccessIds.ACCESS_GROUPS,
    // },
    {
        title: 'SETTINGS.ACCESS.GYMPASS_CHECKIN.SUMMARY_LABEL',
        id: EAccessIds.GYMPASS_CHECKIN,
        requiredModules: [SystemModules.Gympass],
        hiddenPlatformFeatures: [PLATFORM_FEATURES.school],
    },
    {
        title: 'SETTINGS.ACCESS.TOTALPASS_CHECKIN.SUMMARY_LABEL',
        id: EAccessIds.TOTALPASS_CHECKIN,
        requiredModules: [SystemModules.Totalpass],
        hiddenPlatformFeatures: [PLATFORM_FEATURES.school],
    },
    {
        title: 'SETTINGS.CRM.INSTANT_MESSAGING.ACCESS_MESSAGES',
        id: EAccessIds.INSTANT_MESSAGING,
    },
];